import IcRotateRight from './IcRotateRight'

export default IcRotateRight
